const React = require("react");
const FontAwesome = require("components/widgets/FontAwesome");

module.exports = () => {
    return <FontAwesome icon="spinner" spin={true} size={"2x"}/>;
};